export const OAUTH_AUTHORIZE_STATUS = 'OAUTH_AUTHORIZE_STATUS';
export const OAUTH_AUTHORIZE_STATUS_SUCCESS = 'OAUTH_AUTHORIZE_STATUS_SUCCESS';
export const OAUTH_AUTHORIZE_STATUS_ERROR = 'OAUTH_AUTHORIZE_STATUS_ERROR';

export const OAUTH_AUTHORIZE_CONFIRM = 'OAUTH_AUTHORIZE_CONFIRM';
export const OAUTH_AUTHORIZE_CONFIRM_SUCCESS =
  'OAUTH_AUTHORIZE_CONFIRM_SUCCESS';
export const OAUTH_AUTHORIZE_CONFIRM_ERROR = 'OAUTH_AUTHORIZE_CONFIRM_ERROR';
